module.exports = __webpack_public_path__ + "static/c3-305dcdbffa04c34440672fb1cf504bd3.jpg";